import { Components, Theme } from '@mui/material/styles';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    colorDefault: ({ theme }) => ({
      backgroundColor: theme.palette.studio.avatarTones.neutral.bg,
      color: theme.palette.studio.avatarTones.neutral.fg,
    }),
  },
};
